import { Component, OnInit, ViewChild } from '@angular/core';
import { CanaisServiceService } from './canais-service.service';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { AlertComponent } from '../../../alert/alert.component';
import { LoadingModalComponent } from "../../../loading-modal/loading-modal.component";
import { QrcodeComponent } from '../../../qrcode/qrcode.component';


interface ChannelAttributes {
  nomefila: string;
  queueId: string;
  apiKey: string;
  type: 'NORMAL' | 'APIOFICIAL',
  fire: number
}

interface InfoChannelAttributes {
  canaisLiberados: number;
  canaisCadastrados: number;
}

interface RangesInput {
  min: number;
  max: number;
}


@Component({
  selector: 'app-canais',
  standalone: true,
  imports: [MatIconModule, CommonModule, ReactiveFormsModule, FormsModule, AlertComponent, LoadingModalComponent, QrcodeComponent],
  templateUrl: './canais.component.html',
  styleUrls: ['./canais.component.scss'],
  providers:[CanaisServiceService]
})
export class CanaisComponent implements OnInit {
  //Variavel de alertas e loading
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingModal!: LoadingModalComponent;
  @ViewChild(QrcodeComponent) qrcodeComponent!: QrcodeComponent;
  //Variaveis para listagem dos canais
  public isLoadingClients: boolean = false;
  public listChannels: Array<any> = [];
  public infoChannels!: Partial<InfoChannelAttributes>;

  //Variaveis de registro de canais
  public modalRegisterQueue: boolean = false;
  public formRegisterQueue: FormGroup;
  public dataRange: any = {
    min: 1,
    max: 6
  }



  //Variaveis para a edicao do fire dos canais
  public modalEditFireQueue: boolean = false;
  public formEditFireQueue: FormGroup;
  public clientEditFireSelected: any;
  public rangesFireSelected: RangesInput = { min: 1, max: 6 };

  //Variaveis para exclusao de canal
  public modalDeleteQueue: boolean = false;
  public clientDeleteQueueSelected: any;

  constructor(private canaisService: CanaisServiceService, private fb: FormBuilder) {
    this.formRegisterQueue = this.fb.group({
      nomefila: ['', Validators.required],
      queueId: ['', Validators.required],
      apiKey: ['', Validators.required],
      type: ['NORMAL', Validators.required],
      fire: [3, Validators.required]
    });

    this.formEditFireQueue = this.fb.group({
      idcanal: ['', Validators.required],
      fire: ['', Validators.required]
    });

    this.infoChannels = {
      canaisLiberados: 0,
      canaisCadastrados: 0
    }
  }

  async ngOnInit() {
    this.isLoadingClients = true;
    this.listChannels = await this.updateDataViewListChannels();
    this.updateDataViewChannels();
    this.isLoadingClients = false;
  }

  public openModalRegisterQueue() {
    this.modalRegisterQueue = true;
  }

  public closeModalRegisterQueue() {
    this.modalRegisterQueue = false;
    this.formRegisterQueue.reset({
      type: 'NORMAL',
      fire: 3
    });
  }

  public alterType() {
    if (this.formRegisterQueue.value.type === 'NORMAL') {
      this.dataRange.min = 3;
      this.dataRange.max = 6;
      this.formRegisterQueue.patchValue({
        fire: 3
      })
    } else if (this.formRegisterQueue.value.type === 'APIOFICIAL') {
      this.formRegisterQueue.patchValue({
        fire: 1
      })
      this.dataRange.min = 1;
      this.dataRange.max = 200;
    }
  }

  public sendRegistrarCanal() {
   let dataChannel: ChannelAttributes = this.formRegisterQueue.value;
   this.canaisService.setCanal(dataChannel).subscribe(async(response: any) => {
     this.alertComponent.showAlert('Canal registrado com sucesso!','success');
     this.closeModalRegisterQueue();
     this.updateListChannels();
     this.formRegisterQueue.reset({
       type: 'NORMAL',
       fire: 3
     });
   },
   (error: any) => {
     this.alertComponent.showAlert(`Erro ao registrar canal \n ${error.error.status}`, 'error');
   })
  }

  public async updateListChannels(){
    this.listChannels = await this.updateDataViewListChannels();
    this.updateDataViewChannels();
  }

  public async updateDataViewListChannels(): Promise<Array<any>> {
    return new Promise((resolve, reject) => {
      this.canaisService.getCanais().subscribe((response: any) => {
        resolve(response.canais);
      });
      
    })
    
  }

  public async updateDataViewChannels() {
    
    this.canaisService.getConfigUserChannels().subscribe((response: any) => {
      this.infoChannels.canaisLiberados = response.configUser.quantidadecanais;
      this.infoChannels.canaisCadastrados = this.listChannels.length;
    });
  }

  //Funcoes para editar o fire dos canais
  public openModalEditFireQueue(canal: any){
    this.clientEditFireSelected = canal;
    this.formEditFireQueue.patchValue({
      idcanal: canal.idcanal,
      fire: canal.fire
    });
    if(this.clientEditFireSelected.type === 'NORMAL'){
      this.rangesFireSelected = {
        min: 1,
        max: 6
      }
    } else if(this.clientEditFireSelected.type === 'APIOFICIAL'){
        this.rangesFireSelected = {
          min: 1,
          max: 200
        }
    }
    this.modalEditFireQueue = true;
    this.formEditFireQueue.patchValue({
      queueId: 10,
      fire: canal.fire
    })
  }

  public closeModalEditFireQueue(){
    this.modalEditFireQueue = false;
    this.clientEditFireSelected = undefined;
  }

  public sendEditFireQueue(){
    this.loadingModal.activeLoading();
    this.canaisService.updateFireChannel(this.formEditFireQueue.value).subscribe(async(response: any) =>{
      this.alertComponent.showAlert('Canal alterado com sucesso!','success');
      await this.updateListChannels();
      this.formEditFireQueue.reset();
      this.loadingModal.inactiveLoading();
      this.closeModalEditFireQueue();
    }, (error: any) =>{ 
      console.log(error);
      this.alertComponent.showAlert('Erro ao tentar alterar o fire do canal!','error');
      this.closeModalEditFireQueue();
    })
  }

  //Funcoes de deletar fila
  
  public openModalDeleteQueue(canal: any){
    this.clientDeleteQueueSelected = canal;
    this.modalDeleteQueue = true;
  }
  
  public closeModalDeleteQueue(){
    this.clientDeleteQueueSelected = undefined;
    this.modalDeleteQueue = false;
  }

  public sendPedidoDeleteQueue(){
    console.log(this.clientDeleteQueueSelected);
    this.loadingModal.activeLoading();
    this.canaisService.deleteChannelUser(this.clientDeleteQueueSelected.idcanal).subscribe(async(response: any) =>{
      
      this.alertComponent.showAlert('Canal excluído com sucesso!','success');
      await this.updateListChannels();
      this.loadingModal.inactiveLoading();
      this.closeModalDeleteQueue();
    }, (error: any) =>{
      this.alertComponent.showAlert('Erro ao tentar excluir canal!','error');
      this.closeModalDeleteQueue();
    })
  }


  //Funcoes para gerar o qrcode da fila
  public generateQrCode(channel: any){
    console.log("Canal: ",channel);
    this.loadingModal.activeLoading();
    this.canaisService.getQrCode(channel).subscribe(async(response: any) =>{
      this.qrcodeComponent.openQrCodeModal(response.qrcode);
      this.loadingModal.inactiveLoading();
      console.log(response);
    }, (error: any) => {
      console.log(error);
      this.alertComponent.showAlert('Erro ao gerar QRCode!','error');
      this.closeModalDeleteQueue();
      this.loadingModal.inactiveLoading();
    });
  }
}
